<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listMoedas"
        :title-table="$t('Currencies')"
        module="moedaSettingsModule"
        sort-name="nome"
        :show-btn-add="verificarPermissao('ROLE_FINAN_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_FINAN_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <FormMoeda v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import { verificarPermissao } from '@/auth/utils'
import FormMoeda from './forms/FormMoeda.vue'

export default {
  name: 'MoedaSetting',
  components: {
    BRow,
    BCol,
    TableComponents,
    FormMoeda
  },
  computed: {
    ...mapState('moedaSettingsModule', {
      listMoedas: (state) => state.listMoedas
    })
  },
  data() {
    return {
      verificarPermissao,
      showForm: false,
      columns: [
        {
          label: this.$t('id'),
          field: 'id'
        },
        {
          label: this.$t('Name'),
          field: 'nome'
        },
        {
          label: this.$t('Sigla'),
          field: 'descricao'
        },
        {
          label: this.$t('Status'),
          field: 'ativo',
          type: 'boolean'
        },
        {
          label: this.$t('Action'),
          field: 'action'
        }
      ]
    }
  },
  methods: {
    addNew() {
      this.$store.dispatch('moedaSettingsModule/resetMoeda')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('moedaSettingsModule/prepareToEditMoeda', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    }
  }
}
</script>
